import { render } from "./TestifyComponent.vue?vue&type=template&id=6653b14b&scoped=true"
import script from "./TestifyComponent.vue?vue&type=script&lang=js"
export * from "./TestifyComponent.vue?vue&type=script&lang=js"

import "./TestifyComponent.vue?vue&type=style&index=0&id=6653b14b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6653b14b"]])

export default __exports__